import { StyleSheet } from 'react-native';

export const feedBackGridStyles = (theme,isMobile) =>
  StyleSheet.create({
    titleWrapper: {
      paddingHorizontal: 25,
      paddingTop: 25
    },
    filtersContainer: {
      flexDirection: 'row',
      gap: 70,
      marginTop: 50,
      alignItems: 'flex-start'
    },
    filterItem: {
      flex: 1,
      maxWidth: 200,
      gap: 15
    },
    container: {
      borderRadius: isMobile?0:20,
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.1,
      shadowRadius: 12,
      elevation: 6,
      marginVertical: isMobile?0:8,
      marginHorizontal: isMobile?0:8,
      borderWidth: isMobile ? 0 : 1,             
      borderColor: isMobile ? 'transparent' : theme.palette.primaryOutline,
      
    },

    headerContainer: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      paddingBottom: 10,
      minHeight: 120,
      paddingHorizontal: 12,
      borderBottomWidth: 1,
      borderTopWidth: 0,
      borderColor: theme.palette.primaryOutline,
      backgroundColor: theme.palette.backgroundSecondary,
      marginTop: 60
    }
  });
